module.exports = __webpack_public_path__ + "images/fa-cml2024-instructor-gilbert-eijkelenboom.webp";